<template>
  <v-list transition="fade-transition">
    <template v-for="(item, index) in checklistItems">
      <v-list-item class="checklist-item" :key="'item_'+index">
        {{item.display_value}}
      </v-list-item>
      <v-divider
          v-if="index + 1 < checklistItems.length"
          :key="'divider_'+index"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
name: "ChecklistListViewComponent",
  props: {
    checklistItems: {
      type: Array,
      required: true,
      default (){
        return []
      }
    }
  }
}
</script>

<style scoped>

</style>